import {jsx} from 'panel';

import {QueryBlockEl} from 'common/widgets/query-block';
import {serializeAttributes} from 'common/util';

import type {QueryEntrySection} from '../index';
import {QuerySuperEntry} from '../types';

export function RowSelector({
  el,
  entry,
  index,
  isPlaceholder,
}: {
  el: QueryEntrySection;
  entry: QuerySuperEntry;
  index: number;
  isPlaceholder: boolean;
}) {
  const queryBlockConfig = el.helpers.getQueryBlockConfig(entry);
  const {activeEntry, entryPart} = el.state;

  return (
    <QueryBlockEl
      key='entry-selector'
      class={{
        'is-disabled': entry.readOnlyEvent,
        'is-placeholder': isPlaceholder,
      }}
      attrs={serializeAttributes({
        ...queryBlockConfig,
        elref: `entrySelector`,
        open: isPlaceholder && activeEntry === index && entryPart === el.helpers.EntryPart.Value,
        'data-group-id': el.attr(`data-group-id`),
        'enable-enhanced-list-filters': el.attr(`enable-enhanced-list-filters`),
        'enable-workspace-filter-restrictions': el.attr(`enable-workspace-filter-restrictions`),
        'exclude-custom-events': el.attr(`exclude-custom-events`),
        'hide-edit-controls': el.attr(`hide-edit-controls`),
        'inline-cohorts-override': el.attr(`inline-cohorts-override`),
        'project-has-cohorts': el.attr(`project-has-cohorts`),
        'project-id': el.attr(`project-id`),
        selected: entry.event || null,
        'show-special-dataset-property': el.attr(`show-special-dataset-property`),
        'hide-special-date-property-unit': el.attr(`hide-special-date-property-unit`),
        'show-special-date-property': el.attr(`show-special-date-property`),
        theme: `select`,
        'track-name': el.attr(`track-name`),
        'selector-type': `button`,
        'user-id': el.attr(`user-id`),
        disabled: el.attr(`disabled`),
        'workspace-id': el.attr(`workspace-id`),
      })}
      on={{
        close: () => el.helpers.setActiveEntry(`close`, index, el.helpers.EntryPart.Value),
        deletedCustomEvent: el.helpers.handleDeletedCustomEvent,
        savedCustomEvent: el.helpers.propagateEvent,
        open: () => el.helpers.setActiveEntry(`open`, index, el.helpers.EntryPart.Value),
        remove: () => el.helpers.onEventActionClick(el.helpers.Action.Remove, index),
        select: (ev: CustomEvent) => el.helpers.onEventSelected(ev, index),
        track: (ev: CustomEvent) => el.helpers.trackEntrySelectorEvent(ev, index),
      }}
    />
  );
}
